import React, { Component } from 'react';
import TravelBudget3Page from './travel-budget3-html';
class TravelBudget3 extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <TravelBudget3Page
                />
            </div>
        )
    }
}
export default TravelBudget3;